import React from 'react';

class Section extends React.Component {

	constructor(props) {
		super(props);
		//console.log("Section Constructor", props);
	}

	static styles = {
		mainContainer: {
			minHeight: "100vh",
			borderBottom: "2px solid white",
			padding: "15vmin 10vmin 0 10vmin",
		},
		contentContainer: {
			textAlign: "left",
			fontSize: "3vmin",
			lineHeight: "4vmin",
			padding: 0,
			fontWeight: 300,
		},
		title: {
			// color: "#444",
			fontFamily: "Nova Round, sans-serif",
			fontWeight: "bold",
			fontSize: "6vmin",
			lineHeight: "8vmin"
		},
		subTitle: {
			// color: "#454",
			fontSize: "4vmin",
			lineHeight: "6vmin",
		},
		listItem: {
			backgroundColor: "rgba(0,0,0,0.5)",
			padding: "1rem"
		}
	};

	render() {
		return (
			<div style={this.styles.mainContainer}>
				{
					this.props.children
				}
			</div>
		);
	}
};

export default Section;